export const CDN_URL = 'https://ufa-cdn.baibars.club/ufa-app-portal';
export const CURRENCY_SYMBOL = '$';
export const DEFAULT_ERROR_TEXT = 'A Problem Occurred';
export const UNAUTHORIZED = 'Error 401: Access Denied';

const defaultRoute = '/salesforce/users';

export const getHomePageRoute = (route?: string) => {
  return defaultRoute || `/sales/applications${route || ''}`;
};

export * from './toLookups.utils';
